import React from 'react';
import './Info.css';

const Info = () => {
  return (
    <section className="info-section">
      <div className="info-container">
        <div className="info-grid">
          <div className="info-card">
            <div className="info-icon">
              <i className="ri-plant-line"></i>
            </div>
            <h3>Smart Monitoring</h3>
            <p>Real-time sensor data for temperature, humidity, light levels, and soil moisture with precision accuracy.</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <i className="ri-settings-3-line"></i>
            </div>
            <h3>Automated Control</h3>
            <p>Intelligent irrigation and lighting systems that respond to environmental conditions automatically.</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <i className="ri-camera-line"></i>
            </div>
            <h3>Visual Tracking</h3>
            <p>Live camera feeds and time-lapse photography to monitor plant growth and development over time.</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <i className="ri-dashboard-line"></i>
            </div>
            <h3>Data Analytics</h3>
            <p>Advanced analytics and insights to optimize your growing environment and maximize yields.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Info;
